import { Outlet } from 'react-router-dom';
import { useState } from 'react';

// material-ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

// project imports
import Footer from './components/Footer';
import Header from './components/Header';
import SideMenu, { collapsedDrawerWidth, drawerWidth } from './components/SideMenu';

export default function AuthenticatedLayout() {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const activeDrawerWidth = drawerOpen ? drawerWidth : collapsedDrawerWidth;
  const headerHeight = 74;
  const footerHeight = 48;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Header
        drawerOpen={drawerOpen}
        drawerOffset={activeDrawerWidth}
        onDrawerToggle={() => setDrawerOpen((open) => !open)}
        onMobileMenuToggle={() => setMobileDrawerOpen(true)}
        showBrand
      />
      <SideMenu open={drawerOpen} mobileOpen={mobileDrawerOpen} onMobileClose={() => setMobileDrawerOpen(false)} />

      <Box
        component="main"
        sx={{
          position: 'fixed',
          top: headerHeight,
          right: 0,
          bottom: footerHeight,
          left: { xs: 0, lg: activeDrawerWidth },
          overflow: 'hidden',
          bgcolor: 'grey.50',
          transition: (theme) =>
            theme.transitions.create('left', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.shorter
            })
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            boxSizing: 'border-box',
            px: { xs: 1.25, sm: 3 },
            pt: 3,
            pb: 2,
            height: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box sx={{ flexGrow: 1, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Outlet />
          </Box>
        </Container>
      </Box>
      <Footer offsetLeft={{ xs: 0, lg: activeDrawerWidth }} />
    </Box>
  );
}
